import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { NgxPermissionsModule } from 'ngx-permissions';

import { LogoComponent } from '@kr/components';
import { DictionariesStore } from '@kr/store';

import { ShellStore } from '../../shell.store';
import { NavItemComponent } from './components/nav-item/nav-item.component';

@Component({
  imports: [NavItemComponent, LogoComponent, NgxPermissionsModule],
  selector: 'kr-sidebar, [krSidebar]',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  readonly #account = inject(ShellStore);

  dictionaries = inject(DictionariesStore);

  openSupportChat() {
    this.#account.getSupportLink();
  }
}
